<script>
	import { Router, Route } from "svelte-routing";
	import DamageValidation from "./DamageValidation/DamageValidation.svelte";
	import CaseManagement from "./CaseManagement/CaseManagement.svelte";
	import CreateCase from "./CaseManagement/CreateCase/CreateCase.svelte";
	import Validate from "./DamageValidation/Validate/Validate.svelte";
	import Investigate from "./CaseManagement/Investigate/Investigate.svelte";
	import InvestigateDamageValidation from "./CaseManagement/InvestigateDamageValidation/InvestigateDamageValidation.svelte";
	import RejectReportDetails from "./CaseManagement/Rejected/RejectReportDetails.svelte";
	import CaseDetails from "./CaseManagement/CaseDetails/CaseDetails.svelte";
	import { brand } from "src/brand";

	export let location;
</script>

<Router url="/">
	{#if brand.isDamageValidationEnabled}
		<Route path="/damage-validation">
			<DamageValidation />
		</Route>
		<Route path="/damage-validation/:id" let:params>
			<Validate id={params.id} {location} />
		</Route>
	{/if}
	<Route path="/case-management" component={CaseManagement} />
	<Route path="/case-management/create" component={CreateCase} />
	<Route path="/case-management/:id" let:params>
		<Investigate id={params.id} {location} />
	</Route>
	<Route path="/case-management/investigate-damage-validation" let:location>
		<InvestigateDamageValidation {location} />
	</Route>
	<Route path="/case-management/quotation/:id" let:params>
		<CaseDetails id={params.id} {location} />
	</Route>
	<Route path="/case-management/rejected/:id" let:params>
		<RejectReportDetails id={params.id} {location} />
	</Route>
</Router>
